<div
  class="card card-custom"
  [ngClass]="{ 'card-body-progress card-body-progress-overlay': viewLoading }"
>
  <div *ngIf="data.title" class="card-header justify-content-between">
    <div class="card-title">
      <h3 class="card-label">{{ data.title }}</h3>
    </div>
  </div>
  <div class="card-body justify-content-center pt-15">
    <div class="card-body-progress">
      <mat-spinner [diameter]="5"></mat-spinner>
    </div>
    <div
      [innerHtml]="(viewLoading ? data.waitDescription : data.description) | safe : 'html'"
    ></div>
  </div>
  <div *ngIf="data.showCancel || data.showConfirm" class="card-footer justify-content-end">
    <button
      *ngIf="data.showCancel"
      mat-raised-button
      type="button"
      class="btn btn-sm btn-light"
      (click)="cancel($event)"
    >
      {{ data.cancelText }}
    </button>
    <button
      *ngIf="data.showConfirm"
      mat-raised-button
      type="button"
      [disabled]="viewLoading"
      class="btn btn-sm btn-primary ml-15px"
      (click)="confirm($event)"
    >
      {{ data.confirmText }}
    </button>
  </div>
</div>
